module.exports = __webpack_public_path__ + "static/img/bg_circle_radio.6dd402b2.png";